import ButtonV2 from "components/individual/ButtonsV2/Button";
import React, { useContext } from "react";
import { ContextMassiveInvoiceDownload } from "..";

export default function Next() {
  const hook = useContext(ContextMassiveInvoiceDownload);

  return (
    <ButtonV2
      onClick={() => hook.setStep(hook.state.step + 1)}
      disabled={hook.state.step === 1}
    >
      <span>Continuar</span>
    </ButtonV2>
  );
}
